export default{
    fetchLocations(context,payload){
        context.commit('fetchLocations',payload)
    },
    fetchJournalists(context,payload){
        context.commit('fetchJournalists',payload)
    },
}